import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const TagIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/tag"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M6.59998 3.59961C4.94312 3.59961 3.59998 4.94276 3.59998 6.59961V10.054C3.59998 10.8497 3.91605 11.6127 4.47865 12.1753L12.2787 19.9753C13.4502 21.1469 15.3497 21.1469 16.5213 19.9753L19.9757 16.5209C21.1473 15.3494 21.1473 13.4499 19.9757 12.2783L12.1757 4.47829C11.6131 3.91568 10.85 3.59961 10.0544 3.59961H6.59998ZM7.19998 8.39961C7.86272 8.39961 8.39998 7.86235 8.39998 7.19961C8.39998 6.53687 7.86272 5.99961 7.19998 5.99961C6.53723 5.99961 5.99998 6.53687 5.99998 7.19961C5.99998 7.86235 6.53723 8.39961 7.19998 8.39961Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default TagIcon;